import { z } from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"

const createUpdateCategoryFormSchema = z.object({
  name: z.string().min(1, "Category name is required"),
  parentCategoryId: z.string().uuid().nullable(),
  color: z.string().nullable(),
})

export type CreateUpdateCategoryFormValues = z.input<
  typeof createUpdateCategoryFormSchema
>

export const useCreateUpdateCategoryForm = () =>
  useForm({
    validationSchema: toTypedSchema(
      createUpdateCategoryFormSchema
    ),
    initialValues: {
      name: "",
      color: null,
      parentCategoryId: null,
    },
  })
